import type { MapDefinition } from '../../shared/game/world-types.js';
import mapCatalog from './catalog.json' with { type: 'json' };
import { coastCivilians } from '../characters/coast-civilians.js';
import { emberCoastCritters } from '../critters/ember-coast-critters.js';
import { emberCoastGround } from './ember-coast-ground.js';
import { placeNames } from './ember-coast-places.js';

/** The Ember Coast: its generated ground (`ember-coast-ground.ts`) with its name, landmarks, residents and critters. */
export const emberCoast: MapDefinition = { ...emberCoastGround, ...mapCatalog[0], subtitle: 'Sunset shores · Greywake village · The Hollow', landmarks: placeNames, civilians: coastCivilians, critters: emberCoastCritters };
